import { gql } from '@apollo/client';
import { useFeatureCookie } from '@mnd-frontend/hooks';
import { SPACING_1, useTranslation } from '@mnd-frontend/ui';
import styled from 'styled-components';
import { useAdminPanelLinkQuery } from '../../../../generated/hooks';

gql`
  query AdminPanelLink($pressroomId: ID!) {
    pressroom(id: $pressroomId) {
      source {
        id
      }
    }
  }
`;

const Wrapper = styled.div`
  padding: ${SPACING_1};
  margin: ${SPACING_1};
`;

export const AdminPanelLink = ({ pressroomId }: { pressroomId: string }) => {
  const { t } = useTranslation();
  const enableAdminPanelLink = useFeatureCookie('admin_panel_link');
  const { data } = useAdminPanelLinkQuery({
    variables: {
      pressroomId,
    },
  });

  if (!enableAdminPanelLink) return null;

  const sourceId = data?.pressroom?.source?.id;
  if (!sourceId) return null;

  return (
    <Wrapper>
      <a
        href={`https://www.mynewsdesk.com/admin/sources/${sourceId}/pressrooms/${pressroomId}/edit`}
        target="_blank"
        rel="noreferrer"
      >
        {t('open_admin_panel')}
      </a>
    </Wrapper>
  );
};
